(function () {
'use strict';
if(window.WishlistAPI)return;

const APP_URL=(window.wishlistAppUrl||'').replace(/\/$/,'');
const SHOP=window.wishlistShop||(typeof Shopify!=='undefined'?Shopify.shop:'');
const CUSTOMER_ID=window.wishlistCustomerId||null;
const CUSTOMER_EMAIL=window.wishlistCustomerEmail||null;
const GUEST_COOKIE='wl_guest_id';

// ── Guest session cookie ──────────────────────────────────────────────────────
function getCookie(name){const m=document.cookie.match('(?:^|;)\\s*'+name+'=([^;]*)');return m?decodeURIComponent(m[1]):null;}
function setCookie(name,val,days){const d=new Date();d.setTime(d.getTime()+days*864e5);document.cookie=name+'='+encodeURIComponent(val)+';expires='+d.toUTCString()+';path=/;SameSite=Lax';}
function generateGuestId(){return'g_'+Math.random().toString(36).slice(2)+Date.now().toString(36);}
function getOrCreateGuestId(){let id=getCookie(GUEST_COOKIE);if(!id){id=generateGuestId();setCookie(GUEST_COOKIE,id,365);}return id;}

// ── ALWAYS read customerId at runtime not parse time ──────────────────────────
// wishlist-init.liquid sets window.wishlistCustomerId in a <script> tag
// that may not have executed yet when this file is parsed (race condition)
// Reading in a function ensures we always get the latest value
function getCustomerId()    { return window.wishlistCustomerId    || null; }
function getCustomerEmail() { return window.wishlistCustomerEmail || null; }
// Guest session — only create if NOT logged in
// Read at function call time to respect login state
function getGuestSessionId() {
  // If customer is logged in — no guest session
  if (getCustomerId()) return null;
  return getOrCreateGuestId();
}
function toBoolean(value) {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value.trim().toLowerCase() === 'true';
  return false; // null, undefined, or anything else defaults to false
}

// Read at parse time for guest state init only
const GUEST_SESSION_ID=CUSTOMER_ID?null:getOrCreateGuestId();
// Helper to read guest cookie at any time (used during merge after login)
function readGuestCookie(){return getCookie(GUEST_COOKIE);}

// ── State ─────────────────────────────────────────────────────────────────────
const _state={
customerId: getCustomerId(),
customerEmail: getCustomerEmail(),
guestSessionId: getCustomerId() ? null : getOrCreateGuestId(),
shop: SHOP,
lists: [],
loaded: false,
error: null,
};
const _listeners=new Set();
function _emit(){_listeners.forEach(fn=>{try{fn(_state);}catch(e){console.error('[WishlistAPI]',e);}});}

// ── HTTP ─────────────────────────────────────────────────────────────────────
async function _get(path){
  const appUrl=(window.wishlistAppUrl||'').replace(/\/$/,'');
  const res=await fetch(appUrl+path,{credentials:'include'});
  if(!res.ok)throw new Error('GET '+path+' '+res.status);
  return res.json();
}
async function _post(path,body){
  const appUrl=(window.wishlistAppUrl||'').replace(/\/$/,'');
  const res=await fetch(appUrl+path,{method:'POST',headers:{'Content-Type':'application/json'},credentials:'include',body:JSON.stringify(body)});
  if(!res.ok){
    let m=res.status;
    try{const j=await res.json();m=j.error||JSON.stringify(j)||res.status;console.error('[WishlistAPI] POST error',path,res.status,j);}catch(e){}
    throw new Error('POST '+path+' '+m);
  }
  return res.json();
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function toGID(type,id){if(!id)return null;const s=String(id);return s.startsWith('gid://')?s:'gid://shopify/'+type+'/'+s;}
function variantNumeric(gid){return gid?String(gid).replace('gid://shopify/ProductVariant/',''):null;}
function ownerParams(){
  const p=new URLSearchParams({shop:_state.shop});
  if(_state.customerId)p.set('customerId',_state.customerId);
  else p.set('guestSessionId',_state.guestSessionId);
  return p.toString();
}
function ownerBody(){
  const b={shop:_state.shop};
  if(_state.customerId){b.customerId=_state.customerId;b.customerEmail=_state.customerEmail;}
  else b.guestSessionId=_state.guestSessionId;
  return b;
}

// ── API ───────────────────────────────────────────────────────────────────────
const WishlistAPI={
  subscribe(fn){_listeners.add(fn);if(_state.loaded)fn(_state);return()=>_listeners.delete(fn);},
  get state(){return _state;},
  isLoggedIn(){return!!_state.customerId;},
  isGuest(){return!_state.customerId;},

  async load(){
    // Always re-read customerId from window at load time
    // Fixes race condition where wishlist-init.liquid sets the var
    // after wishlist-core.js has already parsed
    const freshCustomerId    = window.wishlistCustomerId    || null;
    const freshCustomerEmail = window.wishlistCustomerEmail || null;
    if(freshCustomerId && freshCustomerId !== _state.customerId){
      // Customer is logged in — update state and clear guest session
      _state.customerId    = freshCustomerId;
      _state.customerEmail = freshCustomerEmail;
      _state.guestSessionId = null;
      // Clear guest cookie so merge only happens once
      const guestCookie = readGuestCookie();
      if(guestCookie){
        // Will be handled by merge block below
      }
    } else if(!_state.customerId && !freshCustomerId) {
      // Still a guest — make sure guest session exists
      _state.guestSessionId = _state.guestSessionId || getOrCreateGuestId();
    }

    // Merge guest lists if customer is now logged in and a guest cookie exists
    // Read the cookie NOW (not at parse time) so it works after login redirects
    if(_state.customerId){
      const guestCookieValue=readGuestCookie();
      if(guestCookieValue){
        try{
          console.log('[WishlistAPI] Merging guest session',guestCookieValue,'into customer',_state.customerId);
          const{lists}=await _post('/api/lists',{
            intent:'merge-guest',
            shop:_state.shop,
            customerId:_state.customerId,
            customerEmail:_state.customerEmail,
            guestSessionId:guestCookieValue,
          });
          // Clear the guest cookie so we don't merge again next page load
          document.cookie=GUEST_COOKIE+'=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
          _state.lists=lists||[];_state.loaded=true;_state.error=null;
          _emit();return;
        }catch(e){
          console.warn('[WishlistAPI] merge failed',e);
          // Clear the cookie anyway to avoid repeated failed merge attempts
          document.cookie=GUEST_COOKIE+'=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
        }
      }
    }
    try{
      const{lists}=await _get('/api/lists?'+ownerParams());
      _state.lists=lists||[];_state.loaded=true;_state.error=null;
    }catch(err){
      console.error('[WishlistAPI] load failed',err);
      _state.loaded=true;_state.error='Failed to load';
    }
    _emit();
  },

  listsContainingProduct(rawId){
    const pid=toGID('Product',rawId);
    return _state.lists.filter(l=>l.items.some(i=>i.productId===pid));
  },

  async createList(name,emoji){
    const{list}=await _post('/api/lists',{intent:'create',...ownerBody(),name:name.trim(),emoji:emoji||'❤️'});
    if(list){list.items=list.items||[];_state.lists.push(list);_emit();}
    return list||null;
  },

  async updateList(listId,updates){
    const{list}=await _post('/api/lists',{intent:'update',...ownerBody(),listId,...updates});
    if(list){const i=_state.lists.findIndex(l=>l.id===listId);if(i!==-1)_state.lists[i]={..._state.lists[i],...list};_emit();}
    return list||null;
  },

  async deleteList(listId){
    await _post('/api/lists',{intent:'delete',...ownerBody(),listId});
    _state.lists=_state.lists.filter(l=>l.id!==listId);_emit();
  },

  async toggleItem(listId,pd){
    const list=_state.lists.find(l=>l.id===listId);
    if(!list)throw new Error('List not found: '+listId);

    // Normalise IDs — toGID is safe to call on already-GID strings
    const pid=toGID('Product',pd.productId);
    // Only build variantId GID if it looks like a real variant (not empty/null)
    const rawVid=pd.variantId&&String(pd.variantId).trim()!==''?pd.variantId:null;
    const vid=rawVid?toGID('ProductVariant',rawVid):null;
    const existing=list.items.find(i=>i.productId===pid&&(!vid||i.variantId===vid));

    if(existing){
      list.items=list.items.filter(i=>i.id!==existing.id);_emit();
      try{
        await _post('/api/items',{intent:'remove',listId,productId:pid,variantId:vid});
        window.WishlistToast&&window.WishlistToast.show('Removed from '+list.name,'success');
      }catch(err){list.items.push(existing);_emit();window.WishlistToast&&window.WishlistToast.show('Could not remove item','error');throw err;}
    }else{
      const tmp={id:'tmp_'+Date.now(),listId,productId:pid,variantId:vid,
        productTitle:pd.productTitle,variantTitle:pd.variantTitle||null,
        variantSku:pd.variantSku||null,productCategory:pd.productCategory||null,
        productVendor:pd.productVendor||null,productType:pd.productType||null,
        productDescription:pd.productDescription||null,
        productImage:pd.productImage||null,productHandle:pd.productHandle||null,
        price:pd.price||null,compareAtPrice:pd.compareAtPrice||null,
        variantAvailable:toBoolean(pd.variantAvailable),
        variantInventory:pd.variantInventory||null,
        quantity:pd.quantity||1,aslsku:pd.aslsku,
        pickupOnly:toBoolean(pd.pickupOnly),
        addedAt:new Date().toISOString()};
      list.items.push(tmp);_emit();
      try{
        const{item}=await _post('/api/items',{
          intent:'add',listId,productId:pid,variantId:vid,
          productTitle:pd.productTitle,variantTitle:pd.variantTitle||null,
          variantSku:pd.variantSku||null,productCategory:pd.productCategory||null,
          productVendor:pd.productVendor||null,productType:pd.productType||null,
          productDescription:pd.productDescription||null,
          productImage:pd.productImage||null,productHandle:pd.productHandle||null,
          price:pd.price||null,compareAtPrice:pd.compareAtPrice||null,
          variantAvailable:toBoolean(pd.variantAvailable),
          quantity:pd.quantity||1,aslsku:pd.aslsku,
          variantInventory:pd.variantInventory||null,
          pickupOnly:toBoolean(pd.pickupOnly),
        });
        const ti=list.items.findIndex(i=>i.id===tmp.id);
        if(ti!==-1&&item)list.items[ti]=item;
        _emit();
        window.WishlistToast&&window.WishlistToast.show('Saved to '+list.name,'success');
      }catch(err){list.items=list.items.filter(i=>i.id!==tmp.id);_emit();window.WishlistToast&&window.WishlistToast.show('Could not save item','error');throw err;}
    }
  },

  // Saves to first list — auto-creates "Default" list if none exist
  async addToFirstList(pd){
    //if(_state.lists.length===0)await WishlistAPI.createList('My Wishlist','🤍');
    
    if(_state.lists.length===0){
      const defaultList=await WishlistAPI.createList('My List','🤍');
      if(!defaultList)throw new Error('Could not create the list');
    }
    return WishlistAPI.toggleItem(_state.lists[0].id,pd);
  },

// Ensures at least one list exists — call before any toggleItem
  async ensureDefaultList(){
    if(_state.lists.length===0){
      const defaultList=await WishlistAPI.createList('My List','🤍');
      if(!defaultList)throw new Error('Could not create the list');
    }
    return _state.lists[0];
  },
  async moveItem(itemId,targetListId){
    await _post('/api/move',{intent:'move',itemId,targetListId});
    for(const list of _state.lists){
      const i=list.items.findIndex(x=>x.id===itemId);
      if(i!==-1){const[item]=list.items.splice(i,1);const t=_state.lists.find(l=>l.id===targetListId);if(t)t.items.push({...item,listId:targetListId});break;}
    }
    _emit();
  },

  async deleteItem(itemId){
    let removed=null,from=null;
    for(const list of _state.lists){const i=list.items.findIndex(x=>x.id===itemId);if(i!==-1){removed=list.items[i];from=list;list.items.splice(i,1);break;}}
    _emit();
    try{await _post('/api/move',{intent:'delete',itemId});}
    catch(err){if(removed&&from)from.items.push(removed);_emit();throw err;}
  },

  async addToCart(variantGID,quantity){
    quantity=quantity||1;
    const id=variantNumeric(variantGID);
    if(!id)throw new Error('Invalid variantId');
    const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity})});
    if(!res.ok)throw new Error('Add to cart failed');
    const cart=await res.json();
    document.dispatchEvent(new CustomEvent('cart:refresh',{detail:cart}));
    document.dispatchEvent(new CustomEvent('cart:open'));
    return cart;
  },

  async searchProducts(query){
    if(!query||query.length<2)return[];
    try{const{products}=await _get('/api/search?shop='+encodeURIComponent(_state.shop)+'&q='+encodeURIComponent(query));return products||[];}
    catch(e){console.error('[WishlistAPI] search failed',e);return[];}
  },

  // Exact product lookup by GID — used by price/stock refresh
  async getProductById(productId){
    if(!productId)return null;
    try{
      const{products}=await _get('/api/search?shop='+encodeURIComponent(_state.shop)+'&productId='+encodeURIComponent(productId));
      return products?.[0]||null;
    }catch(e){console.error('[WishlistAPI] getProductById failed',e);return null;}
  },

  // Exact product lookup by handle
  async getProductByHandle(handle){
    if(!handle)return null;
    try{
      const{products}=await _get('/api/search?shop='+encodeURIComponent(_state.shop)+'&handle='+encodeURIComponent(handle));
      return products?.[0]||null;
    }catch(e){console.error('[WishlistAPI] getProductByHandle failed',e);return null;}
  },

  // Save & Share — pushes list to external REST service, requires login
  async saveAndShare(listId){
    const list=_state.lists.find(l=>l.id===listId);
    if(!list)throw new Error('List not found');

    // Post to external REST service configured in env
    const externalUrl=(window.wishlistExternalApiUrl||'');
    if(externalUrl){
      try{
        await fetch(externalUrl,{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({
            listId:list.id,
            friendlyId:list.friendlyId,
            shop:_state.shop,
            customerId:_state.customerId,
            customerEmail:_state.customerEmail,
            listName:list.name,
            shareUrl:window.location.origin+'/pages/projects?list='+list.friendlyId,
            items:list.items.map(i=>({
              productTitle:i.productTitle,
              variantTitle:i.variantTitle,
              variantSku:i.variantSku,
              productCategory:i.productCategory,
              productType:i.productType,
              aslsku:i.aslsku,
              price:i.price,
              productHandle:i.productHandle,
              quantity:i.quantity,

            })),
            savedAt:new Date().toISOString(),
          }),
        });
      }catch(e){console.warn('[WishlistAPI] external push failed',e);}
    }

    // Return the shareable URL using friendlyId
    return window.location.origin+'/pages/projects?list='+list.friendlyId;
  },

  getLoginUrl(returnPath){
    return(window.wishlistLoginUrl||'/account/login')+'?return_url='+encodeURIComponent(returnPath||window.location.pathname);
  },

  // Persist qty change to DB — debounced by caller to avoid excessive writes
  async updateItemQuantity(itemId, quantity){
    quantity=Math.max(1,parseInt(quantity)||1);
    // Update local state
    for(const list of _state.lists){
      const item=list.items.find(i=>i.id===itemId);
      if(item){item.quantity=quantity;break;}
    }
    // Persist to DB
    try{
      await _post('/api/items',{intent:'update-quantity',itemId,quantity});
    }catch(e){
      console.warn('[WishlistAPI] updateItemQuantity failed',e);
    }
  },

  // Persist updated prices/stock back to DB after a refresh cycle
  async persistPriceUpdates(updates){
   // console.log(updates);
    if(!updates||!updates.length)return;
    const appUrl=(window.wishlistAppUrl||'').replace(/\/$/,'');
    try{
      await fetch(appUrl+'/api/refresh',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        credentials:'include',
        body:JSON.stringify({updates}),
      });
    }catch(e){
      console.warn('[WishlistAPI] persistPriceUpdates failed',e);
    }
  },
};

// ── Expose & flush queue ──────────────────────────────────────────────────────
window.WishlistAPI=WishlistAPI;
if(window._wlQueue&&window._wlQueue.length){window._wlQueue.forEach(fn=>{try{fn(WishlistAPI);}catch(e){}});window._wlQueue=[];}
window.WishlistReady=function(fn){fn(WishlistAPI);};

// ── Auto-load ─────────────────────────────────────────────────────────────────
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',()=>WishlistAPI.load());
}else{
  WishlistAPI.load();
}
})();